import { useEffect, useRef, useState } from 'react';
import * as React from 'react';
import { Dimensions, FlatList } from 'react-native'
// import { ImageUrlDetection } from '../../util/util'
import { Box } from '../BoxNew'
import { EmptyView } from '../EmptyView'
// import CarousalRoomTypesItem from '../Carousal/HotelRoomTypeCarousal/CarousalRoomTypesItem'
import { Image } from '../ImageNew'
import { ItemPositionType, ListData, ListItem, ListItemSelectableType, ListItemType } from '../ListItemNew1'
import { TextLabel } from '../TextLabel'
import { Text } from '../TextNew'
import CarousalAge from './CarousalAge'
// import UserReview from '../UserReview'
import { BarData, CarousalRoomItem, detailsDataComponent } from './CarouselComponents'
import ListFooter from './ListFooter'
import { ListHeader } from './ListHeader'
import { DefaultViewStyles, styles } from './styles'
import { ListHeaderType, ListProps } from './types'
export interface CarousalDotsActionDataType {
  i: number
  selected: number
  scroller: React.RefObject<FlatList<ListData>>
}

interface RenderItemDataType {
  item: ListData
  index: number
  type: ListItemType
  selectablePosition?: ItemPositionType
  selectableType?: ListItemSelectableType
  selected: number | undefined | null
  imagePosition?: ItemPositionType
  handleSelectedIndex: (data: number) => void
  onPress: (args: {
    type: ListItemType
    index: number
    item: ListData
    handleSelectedIndex(index: number): void
  }) => void
  counterData?: (args: { index: number; counterValue: number }) => void
  onChangeText?: (args: { index: number; item: ListData; text: string }) => void
  counterMax?: number
  overlayColor?: string
  selectable?: boolean
}

const deviceWidth = Dimensions.get('window').width

const renderListItem = (args: RenderItemDataType) => {
  if (args.type === ListItemType.CAROUSEL_ROOM) {
    return CarousalRoomItem()
  }
  if (args.type === ListItemType.CAROUSEL_ROOM_TYPES) {
    // return CarousalRoomTypesItem(args.item, args.onPress)
    return (
      <Box>
        <Text>UpcomingBookingsCard</Text>
      </Box>
    )
  }
  if (args.type === ListItemType.UPCOMING) {
    // const props: UpcomingBookingsCardProps = {
    //   data: args.item,
    //   index: args.index,
    // }
    // return UpcomingBookingsCard(props)
    return (
      <Box>
        <Text>UpcomingBookingsCard</Text>
      </Box>
    )
  }
  if (args.type === ListItemType.PREVIOUS) {
    // const props: PrevBookingCardProps = {
    //   bookingObj: args.item,
    //   type: PrevBookingsCardTypes.Default,
    //   index: args.index,
    // }
    // return PrevBookingsCard(props)
    return (
      <Box>
        <Text>PrevBookingsCard</Text>
      </Box>
    )
  }
  if (args.type === ListItemType.FILTER_LABEL) {
    return (
      <TextLabel
        title={args.item.text}
        type="RoundEdgedLabel"
        fontColor={'BLACK_STRIKE'}
        selected={args.item.selected}
        bgColor={'WHITE'}
        selectable={args.selectable}
      />
    )
  }

  if (args.type === ListItemType.USER_REVIEW) {
    // return <UserReview data={args.item} />
    return (
      <Box>
        <Text>UpcomingBookingsCard</Text>
      </Box>
    )
  }

  const handlePress = () => {
    if (args.onPress) {
      args.onPress({
        type: args.type,
        index: args.index,
        item: args.item,
        handleSelectedIndex: args?.handleSelectedIndex,
      })
    }
  }

  const handleChangeText = (text: string) => {
    if (args?.onChangeText) {
      args.onChangeText({
        text,
        index: args.index,
        item: args.item,
      })
    }
  }

  return args.type === ListItemType.CAROUSEL && args.item.image ? (
    <Box {...DefaultViewStyles.imageStyle}>
      <Image source={args.item.image} type="carousel" />
    </Box>
  ) : (
    <ListItem
      data={args.item}
      type={args.type}
      selectablePosition={args.selectablePosition}
      selectableType={args.selectableType}
      imagePosition={args.imagePosition}
      index={args.index}
      onPress={handlePress}
      onChangeText={handleChangeText}
      selected={args.selected === args.index}
      counterValue={(count: any) => args.counterData && args.counterData({ counterValue: count, index: args.index })}
      counterMax={args.counterMax}
      overlayColor={args.overlayColor}
    />
  )
}

const FlatListData = (
  props: ListProps,
  selected: number | undefined | null,
  handleSelectedIndex: (data: number) => void,
  currentOffset: (event: any) => void,
  scroller: React.RefObject<FlatList<ListData>>,
  carousalPosition: number,
) => {
  const {
    horizontal = false,
    type,
    data,
    selectablePosition,
    imagePosition,
    listFooterData,
    listFooterOnPress,
    listFooterType = ListItemType.DEFAULT,
    listHeaderType = ListHeaderType.DEFAULT,
    selectableType,
    listFooterSelectableType,
    listHeaderOnPress,
    listHeaderData,
    onPress,
    counterData,
    getItemLayout,
    snapToOffsets,
    initialScrollIndex,
    decelerationRate,
    disableIntervalMomentum,
    pagingEnabled,
    onChangeText,
    counterMax = Array(data && data.length).fill(0),
    emptyMessage,
    listRetryOnPress,
    overlayColor,
    showCarousalDots = false,
    onMomentumScrollEnd,
    listKey,
    selectable = false,
    ...restProps
  } = props

  const getStickyHeaderIndex = listHeaderData ? 0 : -1

  const { data: dt } = props

  const handleRenderItem = ({ item, index }: any) =>
    renderListItem({
      item,
      index,
      type,
      selectablePosition,
      selectableType,
      selected,
      imagePosition,
      handleSelectedIndex,
      onPress,
      counterData,
      onChangeText,
      overlayColor,
      selectable,
      counterMax: counterMax[index],
    })

  return (
    <Box {...styles[type as keyof typeof styles].listContainer}>
      <FlatList
        listKey={listKey}
        ref={scroller}
        style={styles[type as keyof typeof styles].viewContainerStyle}
        onScroll={currentOffset}
        showsHorizontalScrollIndicator={styles[type as keyof typeof styles].scrollIndicator}
        showsVerticalScrollIndicator={styles[type as keyof typeof styles].scrollIndicator}
        scrollEnabled
        ListEmptyComponent={
          <EmptyView
            isLoading={false}
            onRetry={() => {
              if (listRetryOnPress) {
                listRetryOnPress()
              }
            }}
            loadingMessage="Fetching Data"
            emptyMessage={emptyMessage}
          />
        }
        ListHeaderComponent={
          listHeaderData && <ListHeader onPress={listHeaderOnPress} data={listHeaderData} type={listHeaderType} />
        }
        keyboardDismissMode="on-drag"
        keyboardShouldPersistTaps="always"
        stickyHeaderIndices={[getStickyHeaderIndex]}
        ListFooterComponent={
          listFooterData && (
            <ListFooter
              data={listFooterData}
              type={listFooterType}
              onPress={listFooterOnPress}
              selectableType={listFooterSelectableType}
            />
          )
        }
        contentContainerStyle={[
          styles[type as keyof typeof styles].flatListContainerStyle,
          styles[type as keyof typeof styles].flatListContainerStyleBorder,
        ]}
        ItemSeparatorComponent={styles[type as keyof typeof styles].separator}
        horizontal={horizontal}
        keyExtractor={(_, index) => index.toString()}
        renderItem={handleRenderItem}
        data={dt}
        getItemLayout={getItemLayout}
        decelerationRate={decelerationRate}
        disableIntervalMomentum={disableIntervalMomentum}
        snapToOffsets={snapToOffsets}
        initialScrollIndex={initialScrollIndex}
        pagingEnabled={pagingEnabled}
        onMomentumScrollEnd={onMomentumScrollEnd}
        {...restProps}
      />
      {showCarousalDots && (
        <Box {...styles[type].bottomContainer}>
          <Box {...styles[type].barContainer}>
            {dt.map((_, i) =>
              BarData(
                {
                  i,
                  scroller,
                  selected: carousalPosition,
                },
                type,
              ),
            )}
          </Box>
          <Box>
            {dt[carousalPosition] && dt[carousalPosition].details && detailsDataComponent(dt[carousalPosition], type)}
          </Box>
        </Box>
      )}
    </Box>
  )
}

const List = (props: ListProps) => {
  const scroller = useRef<FlatList<ListData>>(null)
  const [carousalPosition, setCarousalPosition] = useState(
    props.showCarousalDots && props.initialScrollIndex !== undefined ? props.initialScrollIndex : 0,
  )
  const [selected, setSelected] = useState(Number(props.selectedItemIndex) >= 0 ? props.selectedItemIndex : 0)
  const currentOffset = (event: any) => {
    if (props.showCarousalDots) {
      const currentSelected = Math.floor(event.nativeEvent.contentOffset.x / deviceWidth + 0.5)

      if (currentSelected !== carousalPosition) {
        setCarousalPosition(currentSelected)
      }
    }
    if (props.onScroll) {
      props.onScroll(event)
    }
  }

  const handleSelectedIndex = (data: number | null) => {
    setSelected(data)
  }
  // ComponentUpdate
  useEffect(() => {
    if (props.selectedItemIndex !== undefined) {
      setSelected(props.selectedItemIndex)
    }
  }, [props.selectedItemIndex])

  // Component DidMount
  useEffect(() => {
    if (scroller && scroller.current !== null && props.onFlatlistCreated) {
      props.onFlatlistCreated(scroller?.current)
    }
  }, [props])

  if (props.hide) {
    return null
  }

  return FlatListData(props, selected, handleSelectedIndex, currentOffset, scroller, carousalPosition)
}
export { List, ListItemType, ItemPositionType, ListHeader, CarousalAge }
